export enum MeritDirectDialogType {
  Allocation = 'Allocation',
  Support = 'Support'
}
